import { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';

const Parola = ({ text, progress, start, end }) => {
  const opacity = useTransform(progress, [start, end], [0.16, 1]);
  const y = useTransform(progress, [start, end], [10, 0]);
  return (
    <motion.span style={{ opacity, y }} className="mr-[0.28em] inline-block">
      {text}
    </motion.span>
  );
};

/** Separato da ScrubWords: useScroll non deve mai ricevere un ref non montato. */
const Scrub = ({ text, className, testid }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start 0.9', 'end 0.55'],
    layoutEffect: false,
  });
  const parole = text.split(/\s+/);
  const n = parole.length;
  return (
    <p ref={ref} data-testid={testid} className={className}>
      {/* Le parole sono span separati: senza la frase intera lo screen reader le legge attaccate. */}
      <span className="sr-only">{text}</span>
      <span aria-hidden="true">
        {parole.map((w, i) => (
          <Parola
            key={`${w}-${i}`}
            text={w}
            progress={scrollYProgress}
            start={Math.max(0, i / n - 0.06)}
            end={Math.min(1, i / n + 0.12)}
          />
        ))}
      </span>
    </p>
  );
};

/**
 * Un paragrafo che si accende parola per parola mentre scorri: la versione
 * riusabile di ManifestoWords della home. MotionConfig «user» spegne gia' i
 * transform ma non l'opacita': con reduced motion il testo e' semplicemente
 * fermo e pieno.
 */
export const ScrubWords = ({ text, className = '', testid }) => {
  const ridotto = useReducedMotion();
  if (!text) return null;
  if (ridotto) {
    return (
      <p data-testid={testid} className={className}>
        {text}
      </p>
    );
  }
  return <Scrub text={text} className={className} testid={testid} />;
};
